import { ImageProps } from './base';

export default function AmericanExpress({ width = '64px' }: ImageProps) {
  return (
    <svg
      fill='none'
      height='21'
      style={{ height: 'initial', width }}
      viewBox='0 0 32 21'
      width='32'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>American Express</title>
      <mask
        height='21'
        id='mask0_2391_5798'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'alpha' }}
        width='32'
        x='0'
        y='0'
      >
        <rect fill='#016FD0' height='21' width='32' />
      </mask>
      <g mask='url(#mask0_2391_5798)'>
        <rect fill='#016FD0' height='21' rx='4' width='32' />
        <path
          d='M6.2244 16.0656V11.2476H11.5548L12.1267 11.9611L12.7175 11.2476H32.0655V15.7333C32.0655 15.7333 31.5595 16.0608 30.9743 16.0656H20.2609L19.6161 15.3061V16.0656H17.5032V14.7691C17.5032 14.7691 17.2146 14.9501 16.5906 14.9501H15.8714V16.0656H12.6723L12.1012 15.3368L11.5213 16.0656H6.2244Z'
          fill='white'
        />
        <path
          d='M0 7.61637L1.20202 4.93445H3.2808L3.96296 6.43675V4.93445H6.54707L6.95316 6.02027L7.34685 4.93445H18.9468V5.48033C18.9468 5.48033 19.5566 4.93445 20.5588 4.93445L24.3225 4.94704L24.9929 6.42968V4.93445H27.1555L27.7506 5.78611V4.93445H29.933V9.75243H27.7506L27.1803 8.89801V9.75243H24.003L23.6835 8.99294H22.8294L22.5151 9.75243H20.3604C19.4981 9.75243 18.9468 9.21769 18.9468 9.21769V9.75243H15.6981L15.0533 8.99294V9.75243H2.97284L2.65355 8.99294H1.80213L1.48509 9.75243H0V7.61637Z'
          fill='white'
        />
        <path
          d='M1.62664 5.52826L0.00537109 9.13581H1.0609L1.36004 8.41341H3.09911L3.3967 9.13581H4.47548L2.85576 5.52826H1.62664ZM2.22648 6.36784L2.75657 7.6302H1.69484L2.22648 6.36784Z'
          fill='#016FD0'
        />
        <path
          d='M4.5871 9.13496V5.5274L6.08706 5.53274L6.95949 7.85866L7.81103 5.5274H9.299V9.13496H8.35662V6.47676L7.35768 9.13496H6.53121L5.52948 6.47676V9.13496H4.5871Z'
          fill='#016FD0'
        />
        <path
          d='M9.94455 9.13499V5.5274H13.0197V6.33437H10.8969V6.95145H12.9701V7.71094H10.8969V8.35177H13.0197V9.13499H9.94455Z'
          fill='#016FD0'
        />
        <path
          d='M13.5645 5.52826V9.13585H14.5069V7.8542H14.9037L16.0336 9.13585H17.1853L15.9453 7.80674C16.4542 7.76564 16.9791 7.34763 16.9791 6.69865C16.9791 5.93949 16.3565 5.52826 15.6616 5.52826H13.5645ZM14.5069 6.33522H15.5841C15.8426 6.33522 16.0305 6.52867 16.0305 6.71496C16.0305 6.95464 15.787 7.09471 15.5981 7.09471H14.5069V6.33522Z'
          fill='#016FD0'
        />
        <path d='M18.3274 9.13499H17.3652V5.5274H18.3274V9.13499Z' fill='#016FD0' />
        <path
          d='M20.6087 9.13499H20.401C19.3961 9.13499 18.7859 8.37728 18.7859 7.34603C18.7859 6.2893 19.3893 5.5274 20.6583 5.5274H21.6999V6.38183H20.6202C20.1051 6.38183 19.7407 6.7666 19.7407 7.35493C19.7407 8.05358 20.1573 8.34702 20.7575 8.34702H21.0055L20.6087 9.13499Z'
          fill='#016FD0'
        />
        <path
          d='M22.6601 5.52826L21.0388 9.13581H22.0943L22.3935 8.41341H24.1325L24.4301 9.13581H25.5089L23.8892 5.52826H22.6601ZM23.2599 6.36784L23.79 7.6302H22.7283L23.2599 6.36784Z'
          fill='#016FD0'
        />
        <path
          d='M25.6179 9.13499V5.5274H26.816L28.3458 7.79401V5.5274H29.2882V9.13499H28.1288L26.5602 6.80905V9.13499H25.6179Z'
          fill='#016FD0'
        />
        <path
          d='M6.86948 15.4486V11.841H9.94464V12.648H7.82179V13.2651H9.89504V14.0245H7.82179V14.6654H9.94464V15.4486H6.86948Z'
          fill='#016FD0'
        />
        <path
          d='M21.9371 15.4486V11.841H25.0122V12.648H22.8894V13.2651H24.9527V14.0245H22.8894V14.6654H25.0122V15.4486H21.9371Z'
          fill='#016FD0'
        />
        <path
          d='M10.0643 15.4486L11.5616 13.667L10.0287 11.841H11.2159L12.1289 12.9698L13.0449 11.841H14.1857L12.6729 13.6448L14.1729 15.4486H12.9858L12.0994 14.3375L11.2345 15.4486H10.0643Z'
          fill='#016FD0'
        />
        <path
          d='M14.2838 11.8414V15.449H15.251V14.3098H16.243C17.0824 14.3098 17.7186 13.8836 17.7186 13.0548C17.7186 12.3683 17.2196 11.8414 16.3655 11.8414H14.2838ZM15.251 12.6573H16.2957C16.5669 12.6573 16.7607 12.8163 16.7607 13.0726C16.7607 13.3134 16.5679 13.488 16.2926 13.488H15.251V12.6573Z'
          fill='#016FD0'
        />
        <path
          d='M18.1284 11.841V15.4486H19.0707V14.1669H19.4675L20.5975 15.4486H21.7491L20.5091 14.1195C21.018 14.0784 21.543 13.6604 21.543 13.0114C21.543 12.2522 20.9204 11.841 20.2255 11.841H18.1284ZM19.0707 12.648H20.148C20.4064 12.648 20.5944 12.8414 20.5944 13.0277C20.5944 13.2674 20.3508 13.4075 20.1619 13.4075H19.0707V12.648Z'
          fill='#016FD0'
        />
        <path
          d='M25.4494 15.4486V14.6654H27.3355C27.6145 14.6654 27.7353 14.521 27.7353 14.3628C27.7353 14.2111 27.6149 14.0578 27.3355 14.0578H26.4832C25.7424 14.0578 25.3298 13.6258 25.3298 12.9773C25.3298 12.3988 25.7076 11.841 26.8085 11.841H28.6436L28.2468 12.6527H26.6597C26.3563 12.6527 26.2629 12.8051 26.2629 12.9506C26.2629 13.1001 26.3783 13.2651 26.6101 13.2651H27.5028C28.3287 13.2651 28.687 13.7134 28.687 14.3005C28.687 14.9316 28.2877 15.4486 27.4579 15.4486H25.4494Z'
          fill='#016FD0'
        />
        <path
          d='M28.9074 15.4486V14.6654H30.7935C31.0725 14.6654 31.1934 14.521 31.1934 14.3628C31.1934 14.2111 31.0729 14.0578 30.7935 14.0578H29.9412C29.2004 14.0578 28.7878 13.6258 28.7878 12.9773C28.7878 12.3988 29.1656 11.841 30.2665 11.841H32.0642L31.7049 12.6527H30.1177C29.8143 12.6527 29.7209 12.8051 29.7209 12.9506C29.7209 13.1001 29.8363 13.2651 30.0681 13.2651H30.9609C31.7867 13.2651 32.145 13.7134 32.145 14.3005C32.145 14.9316 31.7457 15.4486 30.9159 15.4486H28.9074Z'
          fill='#016FD0'
        />
      </g>
    </svg>
  );
}
